export default (node) => {
  $('#hover-node-card .card-header').text(node.name)
  
  const replyType = node.data.replyType || ''
  const replyTypeText = node.data.replyTypeText || ''

  const buttonText = node.data.buttonText || ''
  
  const postbackId = node.data.postbackId || ''
  const postbackIdText = node.data.postbackIdText || ''

  let html = ''

  html += `<p><strong>Reply type:</strong> ${replyTypeText}</p>`

  if ('post_back' === replyType) {
    if (buttonText && postbackId) {
      html += `<p><strong>Button text:</strong> ${buttonText}</p>`
      html += `<p><strong>Postback ID:</strong> ${postbackIdText}</p>`
    }
  } else if ('new_post_back' === replyType) {
    if (buttonText) {
      html += `<p><strong>Button text:</strong> ${buttonText}</p>`
    }
  }

  if (Object.values(node.data).length > 0) {
    $('#hover-node-card .card-body').html(html)
  } else {
    $('#hover-node-card .card-body').html('')
  }
}